import MigrationMessagingBanner from 'svh-conversations-settings-lib/migration/components/MigrationMessagingBanner';
import { useChatflow } from 'svh-onboarding-config-shared-lib/migration/hooks/useChatflow';
import { getChatflowMigrationStatusUrl } from '../../../urls/getHelpDeskMigrationUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const ChatflowMigrationBanner = ({
  channel
}) => {
  const {
    chatflow
  } = useChatflow({
    channelInstanceId: channel.channelInstanceId
  });
  if (!chatflow) {
    return null;
  }
  return /*#__PURE__*/_jsx(MigrationMessagingBanner, {
    channel: channel,
    viewStatusRoute: getChatflowMigrationStatusUrl(chatflow.id)
  });
};
ChatflowMigrationBanner.displayName = 'ChatflowMigrationBanner';
export default ChatflowMigrationBanner;